/**
 * Shopify AI Try-On Modal - Professional Pink Theme
 * Handles the try-on functionality for Shopify stores
 *
 * UPDATED: Removed slideshow from AI processing step
 */

class ShopifyTryOnModal {
  constructor() {
    
    // this.backendUrl = "https://wacoal-shopify-app-backend.onrender.com";
    this.backendUrl = "https://wacoal-shopify-backend-production.up.railway.app";
    this.currentProduct = null;
    this.currentView = "before";
    this.tryOnResult = null;
    this.uploadedImageFile = null;
    this.currentStep = 1;

    // Zoom functionality
    this.isZoomed = false;
    this.zoomLevel = 1;
    this.maxZoom = 3;
    this.minZoom = 1;
    this.zoomStep = 0.5;
    this.isDragging = false;
    this.dragStart = { x: 0, y: 0 };
    this.currentTransform = { x: 0, y: 0 };

    this.initModal();
  }

  initModal() {
    // Create modal HTML
    const modalHTML = `
      <div id="try-on-modal" class="try-on-modal" style="display: none;">
        <div class="try-on-modal-overlay" onclick="closeTryOnModal()"></div>
        <div class="try-on-modal-content">
          <div class="try-on-modal-header">
            <div class="try-on-header-content">
              <h2>Wacoal AI Try-On</h2>
              <p class="try-on-subheader">ลองชุดแค่คลิกเดียวด้วย AI ไม่ต้องใส่จริง</p>
            </div>
            <button class="try-on-close" onclick="closeTryOnModal()">
            <?xml version="1.0" encoding="utf-8"?> 
              <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;left:6px;top:7px;">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#fff"/>
              </svg>
            </button>
          </div>
          
          <div class="try-on-modal-body">
            <!-- Step Indicator -->
            <div class="try-on-steps" id="try-on-steps">
              <div class="try-on-step active" data-step="1">
                <span class="try-on-step-number">1</span>
                เลือกรูปภาพ
              </div>
              <div class="try-on-step-divider"></div>
              <div class="try-on-step" data-step="2">
                <span class="try-on-step-number">2</span>
                ประมวลผล
              </div>
              <div class="try-on-step-divider"></div>
              <div class="try-on-step" data-step="3">
                <span class="try-on-step-number">3</span>
                ผลลัพธ์
              </div>
            </div>

            <!-- Upload Section -->
            <div class="try-on-upload-section" id="try-on-upload">
              <!-- Product Preview -->
              <div class="try-on-product-preview">
                <img id="try-on-product-preview-image" src="" alt="Product">
                <div class="try-on-product-info">
                  <h4 id="try-on-product-preview-title"></h4>
                </div>
              </div>
              
              <div class="try-on-upload-area">
                <h3>อัปโหลดรูปภาพของคุณ</h3>
                <input type="file" id="try-on-file-input" accept="image/*" style="display: none;">
                <div class="try-on-button-group">
                  <button class="try-on-upload-btn" onclick="document.getElementById('try-on-file-input').click()">
                    <svg class="try-on-icon" viewBox="0 0 24 24">
                      <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/>
                    </svg>
                    อัปโหลดรูป
                  </button>
                  <button class="try-on-camera-btn" onclick="openCamera()">
                    <svg class="try-on-icon" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3.2"/>
                      <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                    </svg>
                    ถ่ายรูป
                  </button>
                </div>
                <p class="try-on-upload-text">รูปภาพของคุณจะถูกใช้เพื่อแสดงผลการลองชุดเท่านั้น</p>
              </div>
            </div>

            <!-- Processing Section -->
            <div class="try-on-processing-section" id="try-on-processing" style="display: none;">
              <div class="try-on-processing-content">
                <div class="try-on-spinner"></div>
                <p>กำลังประมวลผลด้วย AI...</p>
              </div>
            </div>

            <!-- Results Section -->
            <div class="try-on-results-section" id="try-on-results" style="display: none;">
              <!-- View Toggle and Zoom Controls -->
              <div class="try-on-view-toggle-container">
                <div class="try-on-view-toggle">
                  <button class="try-on-view-btn active" data-view="before">ก่อน</button>
                  <button class="try-on-view-btn" data-view="after">หลัง</button>
                </div>
                
                <!-- Zoom Controls -->
                <div class="try-on-zoom-controls">
                  <button class="try-on-zoom-btn" id="zoom-out-btn" title="Zoom Out">
                    <svg class="try-on-icon" viewBox="0 0 24 24">
                      <path d="M19 13H5v-2h14v2z"/>
                    </svg>
                  </button>
                  <span class="try-on-zoom-level" id="zoom-level">100%</span>
                  <button class="try-on-zoom-btn" id="zoom-in-btn" title="Zoom In">
                    <svg class="try-on-icon" viewBox="0 0 24 24">
                      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                    </svg>
                  </button>
                  <button class="try-on-zoom-btn" id="reset-zoom-btn" title="Reset Zoom">
                    <svg class="try-on-icon" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Image Display -->
              <div class="try-on-image-container">
                <div class="try-on-image-display" id="try-on-image-display">
                  <img id="try-on-result-image" src="" alt="Try-on result" draggable="false">
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="try-on-actions">
                <button class="try-on-action-btn icon-only" onclick="tryOnModal.downloadResult()" title="ดาวน์โหลด">
                  <svg class="try-on-icon" viewBox="0 0 24 24">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                </button>
                <button class="try-on-action-btn icon-only" onclick="tryOnModal.shareResult()" title="แชร์">
                  <svg class="try-on-icon" viewBox="0 0 24 24">
                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
                  </svg>
                </button>
                <button class="try-on-action-btn" onclick="tryOnModal.retryUpload()">
                  <svg class="try-on-icon" viewBox="0 0 24 24">
                    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4ล-2.35 2.35z"/>
                  </svg>
                  ลองใหม่
                </button>
                <button class="try-on-action-btn primary" onclick="tryOnModal.addToCart()">
                  <svg class="try-on-icon" viewBox="0 0 24 24">
                    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
                  </svg>
                  ซื้อเลย
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Insert modal into page
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // Add event listeners
    this.setupEventListeners();
  }

  setupEventListeners() {
    // File input change
    document
      .getElementById("try-on-file-input")
      .addEventListener("change", (e) => {
        if (e.target.files[0]) {
          this.uploadedImageFile = e.target.files[0];
          this.processTryOn(e.target.files[0]);
        }
      });

    // View toggle buttons
    document.querySelectorAll(".try-on-view-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this.switchView(e.target.dataset.view);
      });
    });
  }

  updateStep(step) {
    this.currentStep = step;
    document.querySelectorAll(".try-on-step").forEach((stepEl) => {
      const stepNum = parseInt(stepEl.dataset.step);
      if (stepNum <= step) {
        stepEl.classList.add("active");
      } else {
        stepEl.classList.remove("active");
      }
    });
  }

  async processTryOn(file) {
    try {
      // Update to step 2
      this.updateStep(2);

      // Show processing state
      document.getElementById("try-on-upload").style.display = "none";
      document.getElementById("try-on-processing").style.display = "block";

      // Prepare form data
      const formData = new FormData();
      formData.append("userImage", file);
      formData.append("productImageUrl", this.currentProduct.image);
      formData.append(
        "category",
        this.determineProductCategory(this.currentProduct)
      );

      // Call backend API
      const response = await fetch(`${this.backendUrl}/api/try-on`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(
          `Backend error: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();

      if (result.success) {
        this.tryOnResult = result;
        this.showResults();
      } else if (result.detail) {
        const errorInfo = result.detail;
        throw new Error(
          errorInfo.error +
            ": " +
            errorInfo.details +
            (errorInfo.suggestion ? " " + errorInfo.suggestion : "")
        );
      } else {
        throw new Error(result.error || result.details || "Try-on failed");
      }
    } catch (error) {
      // Show helpful error messages in Thai
      let errorMessage =
        "กรุณาลองใหม่อีกครั้งด้วยรูปถ่ายที่:\n• เห็นร่างกายทั้งหมด รวมถึงแขนและขาทั้งสองข้าง\n• ถ่ายในท่ายืนตรง หันหน้าเข้ากล้อง\n• มีแสงสว่างเพียงพอ";

      if (
        error.message.includes("Failed to fetch") ||
        error.message.includes("Network")
      ) {
        errorMessage =
          "ไม่สามารถเชื่อมต่อระบบได้\n\nกรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตและลองใหม่อีกครั้ง";
      } else if (
        error.message.includes("garment") ||
        error.message.includes("product image")
      ) {
        errorMessage =
          "ไม่สามารถโหลดรูปภาพสินค้าได้\n\nกรุณารีเฟรชหน้าจอและลองใหม่อีกครั้ง";
      }

      alert(errorMessage);

      // Reset to upload state
      this.updateStep(1);
      document.getElementById("try-on-processing").style.display = "none";
      document.getElementById("try-on-upload").style.display = "block";
    }
  }

  showResults() {
    // Update to step 3
    this.updateStep(3);

    document.getElementById("try-on-processing").style.display = "none";
    document.getElementById("try-on-results").style.display = "block";

    // Initialize zoom functionality
    setTimeout(() => {
      this.initZoom();
    }, 100);

    // Set initial view to "after"
    this.switchView("after");
  }

  switchView(view) {
    this.currentView = view;

    // Update button states
    document.querySelectorAll(".try-on-view-btn").forEach((btn) => {
      btn.classList.remove("active");
    });
    const activeBtn = document.querySelector(`[data-view="${view}"]`);
    if (activeBtn) activeBtn.classList.add("active");

    // Update image
    const resultImage = document.getElementById("try-on-result-image");

    switch (view) {
      case "before":
        resultImage.src = this.tryOnResult.originalImage;
        break;
      case "after":
        resultImage.src = this.tryOnResult.tryOnImageUrl;
        break;
    }

    // Ensure image is not draggable
    resultImage.draggable = false;
  }

  shareResult() {
    const productTitle = this.currentProduct.title;

    if (navigator.share && navigator.canShare) {
      navigator
        .share({
          title: `Check out my AI try-on result for ${productTitle}`,
          text: `I tried on ${productTitle} using Wacoal's AI Try-On feature!`,
          url: window.location.href,
        })
        .catch(() => {
          this.copyToClipboard();
        });
    } else {
      this.copyToClipboard();
    }
  }

  copyToClipboard() {
    const text = `Check out ${this.currentProduct.title} at ${window.location.href}`;
    navigator.clipboard.writeText(text).then(() => {
      // Optional: show a lightweight toast here if you have a UI element
    });
  }

  downloadResult() {
    const imageUrl = document.getElementById("try-on-result-image").src;
    const downloadBtn = document.querySelector(
      '[onclick="tryOnModal.downloadResult()"]'
    );

    if (!imageUrl) {
      alert("ไม่สามารถดาวน์โหลดรูปภาพได้ กรุณาลองใหม่อีกครั้ง");
      return;
    }

    let originalContent = "";
    // Show loading state
    if (downloadBtn) {
      originalContent = downloadBtn.innerHTML;
      downloadBtn.innerHTML =
        '<svg class="try-on-icon" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
      downloadBtn.disabled = true;
      downloadBtn.style.opacity = "0.7";
    }

    // Clean up product title for filename
    let cleanTitle = this.currentProduct.title
      .replace(/[^\u0E00-\u0E7Fa-zA-Z0-9\s]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, "")
      .toLowerCase()
      .substring(0, 50);

    if (!cleanTitle || cleanTitle.length < 3) {
      cleanTitle = "wacoal-product";
    }

    const timestamp = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    const filename = `wacoal-tryon-${cleanTitle}-${timestamp}.jpg`;

    const performDownload = (blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);

      if (downloadBtn) {
        downloadBtn.innerHTML =
          '<svg class="try-on-icon" viewBox="0 0 24 24"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>';
        downloadBtn.style.opacity = "1";
        setTimeout(() => {
          downloadBtn.innerHTML = originalContent;
          downloadBtn.disabled = false;
        }, 1500);
      }
    };

    if (!imageUrl.startsWith("data:")) {
      fetch(imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          performDownload(blob);
        })
        .catch(() => {
          if (downloadBtn) {
            downloadBtn.innerHTML = originalContent;
            downloadBtn.disabled = false;
            downloadBtn.style.opacity = "1";
          }
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = filename;
          link.target = "_blank";
          link.click();

          alert(
            "กำลังเปิดหน้าต่างใหม่เพื่อดาวน์โหลด กรุณาตรวจสอบการตั้งค่าเบราว์เซอร์"
          );
        });
    } else {
      try {
        const arr = imageUrl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        const blob = new Blob([u8arr], { type: mime });
        performDownload(blob);
      } catch (error) {
        if (downloadBtn) {
          downloadBtn.innerHTML = originalContent;
          downloadBtn.disabled = false;
          downloadBtn.style.opacity = "1";
        }
        alert("ไม่สามารถประมวลผลรูปภาพได้ กรุณาลองใหม่อีกครั้ง");
      }
    }
  }

  // Determine product category based on product data
  determineProductCategory(productData) {
    const title = productData.title.toLowerCase();

    if (title.includes("dress") || title.includes("gown")) {
      return "dress";
    } else if (
      title.includes("top") ||
      title.includes("blouse") ||
      title.includes("shirt") ||
      title.includes("tee")
    ) {
      return "tops";
    } else if (
      title.includes("bottom") ||
      title.includes("pants") ||
      title.includes("jeans") ||
      title.includes("shorts")
    ) {
      return "bottoms";
    } else if (
      title.includes("jacket") ||
      title.includes("coat") ||
      title.includes("blazer")
    ) {
      return "outerwear";
    }

    return "tops";
  }

  retryUpload() {
    // Reset to initial state
    this.tryOnResult = null;
    this.currentView = "after";

    // Clear file input
    const fileInput = document.getElementById("try-on-file-input");
    fileInput.value = "";

    // Reset UI
    this.updateStep(1);
    document.getElementById("try-on-results").style.display = "none";
    document.getElementById("try-on-upload").style.display = "block";
  }

  addToCart() {
    // Get the current variant ID - try multiple sources
    let variantId = this.currentProduct.variantId;

    // Try to get from form
    if (!variantId) {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput) {
          variantId = variantInput.value;
        }
      }
    }

    // Try to get from variant selector
    if (!variantId) {
      const variantSelector = document.querySelector(
        'select[name="id"], input[name="id"]:checked, [data-variant-id]'
      );
      if (variantSelector) {
        variantId = variantSelector.value || variantSelector.dataset.variantId;
      }
    }

    // Get first available variant from product
    if (
      !variantId &&
      window.meta &&
      window.meta.product &&
      window.meta.product.variants
    ) {
      variantId = window.meta.product.variants[0].id;
    }

    if (!variantId) {
      alert("ไม่สามารถเพิ่มสินค้าได้ กรุณาเลือกตัวเลือกสินค้า");
      return;
    }

    // Prepare the request body
    const requestBody = {
      id: parseInt(variantId),
      quantity: 1,
    };

    // Add to cart using Shopify Ajax API
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.description || "Failed to add to cart");
          });
        }
        return response.json();
      })
      .then((data) => {
        // Close modal after adding to cart
        this.close();

        // Update cart count
        this.updateCartUI();

        // Trigger cart update events
        document.dispatchEvent(
          new CustomEvent("cart:updated", { detail: data })
        );

        // Open cart drawer for Prestige theme
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.refresh && cartDrawer.refresh();

          if (cartDrawer.open) {
            cartDrawer.open();
          } else if (cartDrawer.show) {
            cartDrawer.show();
          } else {
            const cartIcon = document.querySelector(
              '[aria-controls="cart-drawer"], [data-action="open-cart-drawer"], .header__cart'
            );
            if (cartIcon) {
              cartIcon.click();
            }
          }
        }

        if (
          window.Shopify &&
          window.Shopify.theme &&
          window.Shopify.theme.pubsub
        ) {
          window.Shopify.theme.pubsub.publish("cart:add", data);
        }
      })
      .catch(() => {
        const addButton = document.querySelector(
          'form[action*="/cart/add"] button[type="submit"], button[name="add"], .product-form__submit'
        );
        if (addButton) {
          addButton.click();
        } else {
          alert("ไม่สามารถเพิ่มสินค้าได้ กรุณาลองใหม่อีกครั้ง");
        }
      });
  }

  updateCartUI() {
    // Update cart count in header
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountSelectors = [
          ".cart-count",
          ".cart-count-bubble",
          ".header__cart-count",
          ".cart-link__bubble",
          "[data-cart-count]",
          ".header__cart-count-bubble",
          ".cart-notification__count",
          "#cart-icon-bubble",
          ".site-header__cart-count",
          ".js-cart-count",
          "cart-count",
        ];

        cartCountSelectors.forEach((selector) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach((element) => {
            element.textContent = cart.item_count;
            element.innerHTML = cart.item_count;
            element.classList.remove("hidden", "hide", "visually-hidden");
            if (cart.item_count > 0) {
              element.style.display = "";
              element.style.visibility = "visible";
            }
          });
        });

        if (window.CartDrawer) {
          window.CartDrawer.refresh();
        }

        if (window.Shopify && window.Shopify.onCartUpdate) {
          window.Shopify.onCartUpdate(cart);
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        window.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch(() => {});
  }

  open(productData) {
    this.currentProduct = productData;

    if (!productData.image) {
      alert(
        "Could not find product image. Please make sure you are on a product page with images."
      );
      return;
    }

    // Update product preview
    document.getElementById("try-on-product-preview-image").src =
      productData.image;
    document.getElementById("try-on-product-preview-title").textContent =
      productData.title;

    // Reset modal state
    this.currentStep = 1;
    this.updateStep(1);
    this.tryOnResult = null;
    this.uploadedImageFile = null;
    document.getElementById("try-on-upload").style.display = "block";
    document.getElementById("try-on-processing").style.display = "none";
    document.getElementById("try-on-results").style.display = "none";

    // Show modal
    document.getElementById("try-on-modal").style.display = "block";
    document.body.style.overflow = "hidden";
  }

  close() {
    document.getElementById("try-on-modal").style.display = "none";
    document.body.style.overflow = "auto";

    // Reset state
    this.currentProduct = null;
    this.tryOnResult = null;
    this.uploadedImageFile = null;
    this.currentView = "before";
    this.currentStep = 1;
  }

  // Zoom Methods
  initZoom() {
    const imageDisplay = document.getElementById("try-on-image-display");
    const image = document.getElementById("try-on-result-image");
    const zoomInBtn = document.getElementById("zoom-in-btn");
    const zoomOutBtn = document.getElementById("zoom-out-btn");
    const resetZoomBtn = document.getElementById("reset-zoom-btn");
    const zoomLevel = document.getElementById("zoom-level");

    if (!imageDisplay || !image) return;

    image.draggable = false;
    image.setAttribute("draggable", "false");

    if (zoomInBtn) {
      zoomInBtn.addEventListener("click", () => this.zoomIn());
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener("click", () => this.zoomOut());
    }
    if (resetZoomBtn) {
      resetZoomBtn.addEventListener("click", () => this.resetZoom());
    }

    imageDisplay.addEventListener("wheel", (e) => {
      e.preventDefault();
      if (e.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    });

    // Touch pinch
    let lastTouchDistance = 0;
    imageDisplay.addEventListener("touchstart", (e) => {
      if (e.touches.length === 2) {
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        lastTouchDistance = Math.sqrt(
          Math.pow(touch2.clientX - touch1.clientX, 2) +
            Math.pow(touch2.clientY - touch1.clientY, 2)
        );
      }
    });

    imageDisplay.addEventListener("touchmove", (e) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        const currentDistance = Math.sqrt(
          Math.pow(touch2.clientX - touch1.clientX, 2) +
            Math.pow(touch2.clientY - touch1.clientY, 2)
        );

        if (lastTouchDistance > 0) {
          const scale = currentDistance / lastTouchDistance;
          if (scale > 1.1) {
            this.zoomIn();
            lastTouchDistance = currentDistance;
          } else if (scale < 0.9) {
            this.zoomOut();
            lastTouchDistance = currentDistance;
          }
        }
      }
    });

    // Drag when zoomed
    imageDisplay.addEventListener("mousedown", (e) => {
      if (this.zoomLevel > 1) {
        e.preventDefault();
        this.isDragging = true;
        this.dragStart = { x: e.clientX, y: e.clientY };
        imageDisplay.style.cursor = "grabbing";
      }
    });

    imageDisplay.addEventListener("mousemove", (e) => {
      if (this.isDragging && this.zoomLevel > 1) {
        e.preventDefault();
        const deltaX = e.clientX - this.dragStart.x;
        const deltaY = e.clientY - this.dragStart.y;

        this.currentTransform.x += deltaX;
        this.currentTransform.y += deltaY;

        this.updateImageTransform();
        this.dragStart = { x: e.clientX, y: e.clientY };
      }
    });

    imageDisplay.addEventListener("mouseup", (e) => {
      if (this.isDragging) e.preventDefault();
      this.isDragging = false;
      imageDisplay.style.cursor = this.zoomLevel > 1 ? "grab" : "default";
    });

    imageDisplay.addEventListener("mouseleave", (e) => {
      if (this.isDragging) e.preventDefault();
      this.isDragging = false;
      imageDisplay.style.cursor = this.zoomLevel > 1 ? "grab" : "default";
    });

    image.addEventListener("dragstart", (e) => {
      if (this.zoomLevel > 1) {
        e.preventDefault();
        return false;
      }
    });

    image.addEventListener("drag", (e) => {
      if (this.zoomLevel > 1) {
        e.preventDefault();
        return false;
      }
    });

    imageDisplay.addEventListener("contextmenu", (e) => {
      if (this.zoomLevel > 1) {
        e.preventDefault();
        return false;
      }
    });
  }

  zoomIn() {
    if (this.zoomLevel < this.maxZoom) {
      this.zoomLevel = Math.min(this.zoomLevel + this.zoomStep, this.maxZoom);
      this.updateZoom();
    }
  }

  zoomOut() {
    if (this.zoomLevel > this.minZoom) {
      this.zoomLevel = Math.max(this.zoomLevel - this.zoomStep, this.minZoom);
      this.updateZoom();
    }
  }

  resetZoom() {
    this.zoomLevel = 1;
    this.currentTransform = { x: 0, y: 0 };
    this.updateZoom();
  }

  updateZoom() {
    const image = document.getElementById("try-on-result-image");
    const zoomLevel = document.getElementById("zoom-level");
    const imageDisplay = document.getElementById("try-on-image-display");

    if (!image) return;

    if (zoomLevel) {
      zoomLevel.textContent = Math.round(this.zoomLevel * 100) + "%";
    }

    this.updateImageTransform();

    if (imageDisplay) {
      imageDisplay.style.cursor = this.zoomLevel > 1 ? "grab" : "default";
    }

    this.updateZoomButtonStates();
  }

  updateImageTransform() {
    const image = document.getElementById("try-on-result-image");
    if (!image) return;

    const transform = `scale(${this.zoomLevel}) translate(${
      this.currentTransform.x / this.zoomLevel
    }px, ${this.currentTransform.y / this.zoomLevel}px)`;
    image.style.transform = transform;
    image.style.transition = this.isDragging ? "none" : "transform 0.3s ease";
  }

  updateZoomButtonStates() {
    const zoomInBtn = document.getElementById("zoom-in-btn");
    const zoomOutBtn = document.getElementById("zoom-out-btn");

    if (zoomInBtn) {
      zoomInBtn.disabled = this.zoomLevel >= this.maxZoom;
      zoomInBtn.style.opacity = this.zoomLevel >= this.maxZoom ? "0.5" : "1";
    }

    if (zoomOutBtn) {
      zoomOutBtn.disabled = this.zoomLevel <= this.minZoom;
      zoomOutBtn.style.opacity = this.zoomLevel <= this.minZoom ? "0.5" : "1";
    }
  }
}

// Initialize modal when page loads
let tryOnModal;
document.addEventListener("DOMContentLoaded", () => {
  tryOnModal = new ShopifyTryOnModal();
});

// Global functions for button clicks
function openTryOnModal(button) {
  const productImage = extractProductImageFromSlideshow();

  const form = document.querySelector('form[action*="/cart/add"]');
  let variantId = null;
  if (form) {
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) {
      variantId = variantInput.value;
    }
  }

  const productData = {
    id: button.dataset.productId,
    variantId: variantId,
    image: productImage,
    title: button.dataset.productTitle,
    price: button.dataset.productPrice,
    url: button.dataset.productUrl,
  };

  tryOnModal.open(productData);
}

// Function to extract the current product image from Shopify slideshow/gallery
function extractProductImageFromSlideshow() {
  let imageUrl = null;

  const productGalleryImg = document.querySelector(
    ".t4s-product__media img"
  );
  
  if (productGalleryImg) {
    imageUrl = productGalleryImg.srcset || productGalleryImg.src;
  }

  if (!imageUrl) {
    const mediaGallery = document.querySelector("media-gallery");
    if (mediaGallery) {
      const activeSlide = mediaGallery.querySelector(
        'slideshow-slide:not([aria-hidden="true"])'
      );
      if (activeSlide) {
        const img = activeSlide.querySelector(".product-media__image, img");
        if (img) {
          imageUrl = img.getAttribute("data_max_resolution") || img.src;
        }
      }
      if (!imageUrl) {
        const galleryImg = mediaGallery.querySelector(
          ".product-media__image, img"
        );
        if (galleryImg) {
          imageUrl =
            galleryImg.getAttribute("data_max_resolution") || galleryImg.src;
        }
      }
    }
  }

  if (!imageUrl) {
    const selectors = [
      ".product__media img",
      ".product-single__media img",
      ".product-image img",
      ".product-photo img",
      "[data-product-featured-image]",
      ".product-single__photo img",
      ".product__main-photos img",
      'img[alt*="product"]',
      'img[src*="/products/"]',
      'img[src*="/files/"]',
    ];

    for (const selector of selectors) {
      const img = document.querySelector(selector);
      if (img && img.src) {
        imageUrl = img.src;
        break;
      }
    }
  }

  if (imageUrl && imageUrl.startsWith("//")) {
    imageUrl = "https:" + imageUrl;
  }

  if (!imageUrl) {
    console.log("Searched selectors:", [
      ".product-gallery__media img",
      "media-gallery",
      ".product__media img",
    ]);
    return null;
  }

  console.log("Extracted product image URL:", imageUrl);
  return imageUrl;
}

function closeTryOnModal() {
  tryOnModal.close();
}

function openCamera() {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  if (isMobile) {
    const cameraInput = document.createElement("input");
    cameraInput.type = "file";
    cameraInput.accept = "image/*";
    cameraInput.capture = "user";

    cameraInput.onchange = function (e) {
      if (e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        const fileInput = document.getElementById("try-on-file-input");
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event);
      }
    };

    cameraInput.click();
  } else {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      showCameraInterface();
    } else {
      alert(
        "Camera access is not supported in your browser. Please use the upload option."
      );
    }
  }
}

function showCameraInterface() {
  const cameraModal = document.createElement("div");
  cameraModal.innerHTML = `
    <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.9); z-index: 10001; display: flex; align-items: center; justify-content: center;">
      <div style="background: white; padding: 24px; border-radius: 20px; max-width: 480px; width: 90%; text-align: center; box-shadow: 0 20px 40px rgba(0,0,0,0.3);">
        <h3 style="margin: 0 0 16px 0; color: #424242; font-size: 20px; font-weight: 600;">ถ่ายภาพ</h3>
        <div style="display: flex; justify-content: center; margin-bottom: 20px;">
          <video id="camera-video" style="width: 100%; max-width: 360px; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" autoplay></video>
        </div>
        <canvas id="camera-canvas" style="display: none;"></canvas>
        <div style="display: flex; gap: 10px; justify-content: center; max-width: 280px; margin: 0 auto;">
          <button id="capture-btn" style="background: #e91e63; color: white; border: none; padding: 10px 24px; border-radius: 22px; font-size: 13px; font-weight: 600; cursor: pointer; flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; transition: all 0.3s ease;">
            <svg style="width: 15px; height: 15px;" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="3.2"/>
              <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
            </svg>
            ถ่าย
          </button>
          <button id="cancel-camera" style="background: transparent; color: #e91e63; border: 2px solid #e91e63; padding: 10px 24px; border-radius: 22px; font-size: 13px; font-weight: 600; cursor: pointer; flex: 1; transition: all 0.3s ease;">ยกเลิก</button>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(cameraModal);

  const video = document.getElementById("camera-video");
  const canvas = document.getElementById("camera-canvas");
  const captureBtn = document.getElementById("capture-btn");
  const cancelBtn = document.getElementById("cancel-camera");

  navigator.mediaDevices
    .getUserMedia({ video: { facingMode: "user" } })
    .then((stream) => {
      video.srcObject = stream;

      captureBtn.onclick = () => {
        captureBtn.disabled = true;
        cancelBtn.disabled = true;

        const countdownDiv = document.createElement("div");
        countdownDiv.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 72px;
          font-weight: bold;
          color: white;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          z-index: 1000;
        `;
        video.parentElement.style.position = "relative";
        video.parentElement.appendChild(countdownDiv);

        let count = 3;
        countdownDiv.textContent = count;

        const countdownInterval = setInterval(() => {
          count--;
          if (count > 0) {
            countdownDiv.textContent = count;
          } else {
            clearInterval(countdownInterval);
            countdownDiv.remove();

            video.style.filter = "brightness(2)";
            setTimeout(() => {
              video.style.filter = "brightness(1)";
            }, 100);

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0);

            canvas.toBlob(
              (blob) => {
                const file = new File([blob], "camera-photo.jpg", {
                  type: "image/jpeg",
                });

                const fileInput = document.getElementById("try-on-file-input");
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(file);
                fileInput.files = dataTransfer.files;

                const event = new Event("change", { bubbles: true });
                fileInput.dispatchEvent(event);

                stream.getTracks().forEach((track) => track.stop());
                document.body.removeChild(cameraModal);
              },
              "image/jpeg",
              0.9
            );
          }
        }, 1000);
      };

      cancelBtn.onclick = () => {
        stream.getTracks().forEach((track) => track.stop());
        document.body.removeChild(cameraModal);
      };
    })
    .catch((err) => {
      console.error("Camera error:", err);
      alert(
        "Unable to access camera. Please make sure you have granted camera permissions."
      );
      document.body.removeChild(cameraModal);
    });
}